<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
        <div class="w-100">
			<part1_admin_btns
				:flds="flds"
				@click="(e)=>{$emit('click', e);}"
				v-if="$localStorage.get('user').username.role==3" 
				class="d-flex" 
				style="justify-content: space-between;" 
			/>
			<select 
			class="form-control w-100"
			style="border-radius: 10px;"
			@change="(e)=>{select_search(e)}"
			v-else>
				<option value="all">همه</option>
				<option v-for="(f, i) in select_fld" :key="i">
					{{ f }}
				</option>
			  </select>
			  <hr>
			  <div class="row">
				<div class="col-6">
				<b>
					فهرست تیکت ها
				</b>
				</div>
				<div class="col-6">
					<router-link to="/ticket/create" v-if="$localStorage.get('user').username.role!=3">
						<btn 
						class="d-flex justify-content-end"
						textClass=""
						style_btn=""
						text="+ تیکت جدید"
						/>
					</router-link>
					<div v-else>
						<div class="" style="display: flex; flex-direction: row-reverse; margin-bottom: 28px; margin-top: 28px;">
							<div class="text-14 text-success">
								فیلتر ها
							</div>
							<div>
								<span class="text-14 text-gray pointer" style="margin-left: 40px;" @click="clean_filter()">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M2.81817 2.81524C3.01973 2.61367 3.34652 2.61367 3.54808 2.81524L8.00033 7.26746L12.4526 2.81524C12.6541 2.61367 12.9809 2.61367 13.1825 2.81524C13.3841 3.0168 13.3841 3.34359 13.1825 3.54515L8.73026 7.9974L13.1825 12.4497C13.3841 12.6512 13.3841 12.978 13.1825 13.1795C12.9809 13.3811 12.6541 13.3811 12.4526 13.1795L8.00033 8.72733L3.54808 13.1795C3.34652 13.3811 3.01973 13.3811 2.81817 13.1795C2.6166 12.978 2.6166 12.6512 2.81817 12.4497L7.27039 7.9974L2.81817 3.54515C2.6166 3.34359 2.6166 3.0168 2.81817 2.81524Z" fill="#676767"/>
									</svg>	
									حذف فیلترها
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 d-flex direction-row-reverse justify-content-end" v-if="$localStorage.get('user').username.role==3" style="margin-bottom: 28px;">
					<select class="form-control mr-1" @change="(e)=>{set_filter(e.target.value, 'importances')}" v-model="$route.query.importances">
						<option value="" hidden>درجه اهمیت</option>
						<option value="">همه</option>
						<option v-for="(imp, i) in importances" :key="i" :value="imp.name" >
							{{ imp.name }}
						</option>
					</select>
					
					<select class="form-control mr-1" @change="(e)=>{set_filter(e.target.value, 'CRM')}" v-model="$route.query.CRM"  v-if="$localStorage.get('user').username.access_level==0">
						<option value="" hidden>کارشناس CRM</option>
						<option value="0" hidden>کارشناس CRM</option>
						<option value="0">همه</option>
						<option 
							v-for="(crm, i) in flds.data.CRMS" :key="i"
							:value="crm.id"
						>
							{{ crm.fullname }}
						</option>
					</select>
					<inputcalender_filter 
					:date="$route.query.date"
					label="" 
					placeholder="تاریخ ایجاد آخرین تیکت"
					leading=""
					input_style="border: 1px solid #d2d2e4;"
					class="mr-1"
					:img="require('../../assets/img/Calendar.svg')"
					@inputdate="(e)=>{set_filter(e, 'date')}"
					/>
				</div>
			  </div>
			<table class="table">
				<thead>
					<tr>
						<th>عنوان تیکت</th>
						<th v-if="$localStorage.get('user').username.role==3" >مشخصات کاربر</th>
						<th v-if="$localStorage.get('user').username.role==3" >درجه اهمیت</th>
						<th v-if="$localStorage.get('user').username.role==2 || ($localStorage.get('user').username.role==3 && $localStorage.get('user').username.access_level==0)">
							کارشناس پشتیبانی
						</th>
						<th>دپارتمان</th>
						<th>تاریخ ایجاد</th>
						<th>شماره تیکت</th>
						<th>آخرین به روزرسانی</th>
						<th v-if="$localStorage.get('user').username.role!=3">وضعیت تیکت</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr 
					v-for="(f, i) in flds.data.content" :key="i"
					v-if="f.subject==select_search_val || select_search_val=='all'"
					>
						<td
						:style="(f.read_user==1) ? 'background-image: url('+require('../../assets/img/circle.svg')+');': ''"
						style="background-repeat: no-repeat;
						background-position-x: 98%;
						background-position-y: 15%;"
						:title="(f.read_user==1 && $localStorage.get('user').username.role==3) ? ('تیکت توسط '+f.teachers_fullname+' خوانده نشده است.') : ''"
						>
							{{ f.subject }}
						</td>
						<td v-if="$localStorage.get('user').username.role==3" 
						style="display: flex;
						flex-direction: column;
						align-items: center;">
							{{ f.teachers_fullname }}
							<br>
							<span style="color:#A7A9AC;">
								{{ f.teachers_phone }}
							</span>
						</td>
						<td v-if="$localStorage.get('user').username.role==3">{{ f.messege[0].importance }}</td>
						<td v-if="$localStorage.get('user').username.role==2">{{ f.crm }}</td>
						<td v-if="$localStorage.get('user').username.role==3 && $localStorage.get('user').username.access_level==0">
							<select 
							class="form-control"
							style="border: none; background-color: unset;"
							@change="(e)=>{set_CRM(f.id, e)}"
							>
								<option value="0">ندارد</option>
								<option 
									v-for="(crm, j) in flds.data.CRMS" :key="j"
									:selected="crm.id==f.admins_id"
									:value="crm.id"
								>
									{{ crm.fullname }}
								</option>
							</select>
						</td>
						<td v-if="$localStorage.get('user').username.role==1 || ($localStorage.get('user').username.role==3 && $localStorage.get('user').username.access_level==3)">
							{{ f.field }}
						</td>
						<td v-else-if="$localStorage.get('user').username.role==3 && $localStorage.get('user').username.access_level==0">
							<select 
							class="form-control"
							style="border: none; background-color: unset;"
							@change="(e)=>{set_field(f.id, e)}"
							>
								<option value="0">ندارد</option>
								<option 
									v-for="(field, j) in flds.data.field" :key="j"
									:selected="field.id==f.field"
									:value="field.id"
								>
									{{ field.name }}
								</option>
							</select>
						</td>
						<td>{{ f.date_start }}</td>
						<td>{{ f.code }}</td>
						<td>{{ f.date_end }}</td>
						<td  v-if="$localStorage.get('user').username.role!=3" :style="'color:'+read_crm[f.read_crm].color">
							<b>
								{{ read_crm[f.read_crm].name }}
							</b>
						</td>
						<td>
							<router-link :to="'/ticket/'+f.id">
								<btn 
								textClass="w-100"
								style_btn="padding:5px !important;"
								text="مشاهده"
								/>
							</router-link>
						</td>
					</tr>

				</tbody>
			</table>
			<pageNavigation class="w-100 mt-3" style="display: flex; justify-content: center;" :page="flds.data.query.page" :pages="flds.data.totalPages" @setPage="(e)=>{$emit('click', e);}"  />
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import part1_admin_btns from  "./part1_admin_btns.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import inputcalender_filter from  "../../UI/calendar/inputcalender_filter.vue";
		import { success } from "../../assets/library/messege.js";
		import * as read_crm_json from  "./read_crm.json";
		import * as subjects_teacher_json from  "./subjects_teacher.json";
		import * as subjects_user_json from  "./subjects_user.json";

		import * as importances_json from  "./importances.json";

		export default {
			name: 'part1_empty',
			data(){
				return {
					success: success,
					select_fld: [],
					select_search_val: 'all',
					read_crm: read_crm_json.default,					
					subjects: ((this.$route.query.knd_user=='users') ?  subjects_user_json.default: subjects_teacher_json.default) ,
					importances: importances_json.default
				}
			},
			components: {
				btn,
				part1_admin_btns,
				pageNavigation,
				inputcalender_filter
			},
			props: ["flds"],
			mounted(){
                for (let i = 0; i < this.flds.data.content.length; i++) {
					if (!this.select_fld.includes(this.flds.data.content[i].subject)) {
						this.select_fld.push(this.flds.data.content[i].subject);
					}
				}
			},
			methods:{
				clean_filter(){
					this.$router.push({query: {
						CRM : '0',
						date : '',
						importances: "",
						search: "",
						page: '1',
						search: '',
						subjects: '',
						knd_user: this.$route.query.knd_user
					}
				});
				this.$emit("click", "");

				},
				set_filter(e, set){
					let query = [];
                    for (let q in this.$route.query) {
                        if (q != set) {
                            query[q] = this.$route.query[q];
                        }
                    }
					query.page = 1;
					query[set] = e;
                    this.$router.push({query: query});


					this.$router.push({query: query});
					this.$emit("click", "");
				},
				//**************************************************
				set_CRM(id, e, THIS= this){
					window.$.post(window.baseurl+'ticket/'+id, {
						token: this.$localStorage.get("user"),
						status: "set-CRM",
						CRM: e.target.value,
					}, function(D){
						THIS.success(THIS)
					}, "json");
				},
				//**************************************************
				set_field(id, e, THIS= this){
					window.$.post(window.baseurl+'ticket/'+id, {
						token: this.$localStorage.get("user"),
						status: "set-field",
						field: e.target.value,
					}, function(D){
						THIS.success(THIS)
					}, "json");
				},
				//**************************************************
				select_search(e){
					this.select_search_val = e.target.value;
				}
			}
		}
	</script>
<style scoped>
.table thead th, table th {
	background:#fff !important;
	color: #1b60c6;
	font-size: 12px;
	text-align: center;
}
td{
	text-align: center;
	font-size: 12px;
	color: #676767;
	border: none;
}
tr:nth-child(odd){
	background-color: #F5FAFD;
}
tr:nth-child(even){
	background-color:#fff;
}
select{
	background-color: #F5FAFD;
	border-radius: 10px;
	width: 124px;
}
</style>
